// extracted by mini-css-extract-plugin
module.exports = {"button":"landing_button__7yf8I","action":"landing_action__ZYiOu","gray":"landing_gray__Wt_y1","primary":"landing_primary__iSL6_","secondry":"landing_secondry__G9KsX"};